export const LOGO_URL = "https://customer-assets-rejwkqb3.emergentagent.net/job_live-pricing-stock/artifacts/8x8je3hz_Logo_Trans.webp";
